module.exports = __webpack_public_path__ + "static/media/meter-water.4fd851ff.svg";